import { DatePicker } from 'antd';
import { RangePickerValue } from 'antd/lib/date-picker/interface';
import locale from 'antd/lib/date-picker/locale/de_DE';
import * as moment from 'moment';
import { Moment } from 'moment';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';
import { IconPaths } from 'src/icons';
import { ApplicationState } from 'src/store';
import { getSeasons, updateSeason, deleteSeason } from 'src/store/season/actions';
import { ISeasonData, Season } from 'src/store/season/types';
import { formatDate } from 'src/utils/dateHelper';
import CreateSeason from './CreateSeason';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Footer from 'src/components/layout/Footer/Footer';

const { RangePicker } = DatePicker;

interface Props {
  seasonData: ISeasonData;
  updateSeason: typeof updateSeason;
  getSeasons: typeof getSeasons;
  loading: boolean;
  deleteSeason: typeof deleteSeason;
}

interface State {
  selected?: number;
  value: any;
}

const initialValues = {
  selected: undefined,
  value: undefined
};

type AllProps = Props & RouteComponentProps<any>;

class SeasonManagement extends React.Component<AllProps, State> {
  sectionTitle: string;

  constructor(props: AllProps) {
    super(props);

    this.state = initialValues;
  }

  componentDidMount() {
    this.sectionTitle = this.props.match.params.sectionTitle;
    this.props.getSeasons(this.sectionTitle);
  }

  render() {
    const { seasonData, loading } = this.props;

    return (
      <React.Fragment>
        <div className="container">
          <div className="col-lg-8 centered" style={{ marginBottom: '80px' }}>
            <h2 style={{ textAlign: 'left' }}>Saisonen editieren</h2>
            <LoadingSpinner pending={loading} />
            <table className="styledTable">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Titel</th>
                  <th>Datumsbereich</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {seasonData.bySectionTitle[this.sectionTitle] &&
                  seasonData.bySectionTitle[this.sectionTitle].length > 0 &&
                  seasonData.bySectionTitle[this.sectionTitle].map((id: number, index: number) => {
                    const season = seasonData.byId[id];

                    if (season.id === this.state.selected) {
                      return this.seasonEditView(season, index);
                    } else {
                      return this.seasonView(season, index);
                    }
                  })}
              </tbody>
            </table>
          </div>
          <CreateSeason {...this.props} />
        </div>
        <Footer />
      </React.Fragment>
    );
  }

  seasonView = (season: Season, key: number) => {
    return (
      <tr key={key}>
        <td>{season.id}</td>
        <td>{season.title}</td>
        <td>{`${formatDate(season.startdate, 'DD.MM.YYYY')} - ${formatDate(
          season.enddate,
          'DD.MM.YYYY'
        )}`}</td>
        <td>
          <div className="flexer">
            <img
              className="pointer"
              src={IconPaths['edit-icon']}
              onClick={this.onEdit.bind(this, season)}
              title="Bearbeiten"
              height="20px"
              width="auto"
            />
            <img
              style={{ marginLeft: '10px' }}
              className="pointer"
              src={IconPaths['bin-icon']}
              onClick={this.onDelete.bind(this, season)}
              title="Löschen"
              height="20px"
              width="auto"
            />
          </div>
        </td>
      </tr>
    );
  };

  seasonEditView = (season: Season, key: number) => {
    return (
      <tr key={key}>
        <td>{season.id}</td>
        <td>
          <input
            autoComplete="off"
            type="text"
            value={this.state.value.title}
            name="title"
            onChange={this.onChangeSeason}
          />
        </td>
        <td>
          <RangePicker
            format="DD.MM.YYYY"
            locale={locale}
            onChange={(dates: RangePickerValue) => {
              this.onChangeDateRange(dates[0], dates[1]);
            }}
            defaultPickerValue={[moment(season.startdate), moment(season.enddate)]}
            defaultValue={[moment(season.startdate), moment(season.enddate)]}
          />
        </td>
        <td>
          <div className="flexer">
            <button onClick={this.onSave} className="noStyle">
              <img src={IconPaths['save-icon']} title="Speichern" height="20px" width="auto" />
            </button>
            <button onClick={this.onCancel} className="noStyle">
              <img src={IconPaths['cancel-icon']} title="Abbrechen" height="20px" width="auto" />
            </button>
          </div>
        </td>
      </tr>
    );
  };

  onEdit = (season: Season) => {
    this.setState(
      prevState => {
        return {
          ...prevState,
          selected: season.id,
          value: season
        };
      },
      () => {
        console.log(this.state);
      }
    );
  };

  onDelete = (season: Season) => {
    confirmAlert({
      title: 'Saison löschen',
      message: 'Wollen Sie diese Saison wirklich löschen?',
      buttons: [
        {
          label: 'Löschen',
          onClick: () => this.props.deleteSeason(season, this.sectionTitle)
        },
        {
          label: 'Abbrechen',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  onChangeDateRange = (startdate?: Moment, enddate?: Moment) => {
    if (startdate && enddate) {
      this.setState(prevState => {
        return {
          ...prevState,
          value: {
            ...prevState.value,
            startdate,
            enddate
          }
        };
      });
    }
  };

  onChangeSeason = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const name = e.target.name;

    this.setState(prevState => {
      return {
        ...prevState,
        value: {
          ...prevState.value,
          [name]: inputValue
        }
      };
    });
  };

  onCancel = () => {
    this.setState({ ...initialValues });
  };

  onSave = () => {
    this.props.updateSeason(this.state.value, this.sectionTitle, () => {
      this.onCancel();
    });
  };
}

const mapStateToProps = ({ season }: ApplicationState) => ({
  seasonData: season.data,
  loading: season.loading
});

const mapDispatchToProps = (dispatch: any) => ({
  getSeasons: (sectionTitle: string) => dispatch(getSeasons(sectionTitle)),
  updateSeason: (season: Season, sectionTitle: string, successCB: () => any) =>
    dispatch(updateSeason(season, sectionTitle, successCB)),
  deleteSeason: (season: Season, sectionTitle: string) =>
    dispatch(deleteSeason(season, sectionTitle))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SeasonManagement);



// WEBPACK FOOTER //
// ./src/pages/Management/SeasonManagement/SeasonManagement.tsx